import LoaderSpin from '@/components/snippets/loader-spin/loader-spin'
import { useEffect, useState } from 'preact/hooks'

/** @typedef {'ready' | 'running' | 'success' | 'error'} Status */
/** @typedef {{ config: {data: any, message: string}}} SuspenseConfig */

/**
 *
 * @param {{props: {skipLoad:boolean, asyncCallback: () => Promise<boolean>},useSoftReload: boolean, loadingState: ReadOnly<React.ReactNode>, children: ReadOnly<React.ReactNode>, refetch?: number}}
 * @returns
 */
export const Suspense = ({ children, props, loadingState, useSoftReload, className, refetch }) => {
  /** @type {[Status, React.Dispatch<React.SetStateAction<Status>>]} */
  const [status, setStatus] = useState('ready')
  const [errorMessage, setErrorMessage] = useState()

  /**
   *
   * @param {Status} status
   */
  const handleStatus = (status) => {
    setStatus(status)
  }

  useEffect(() => {
    if (props?.skipLoad) {
      handleStatus('success')
      return
    }

    handleStatus('running')
    props
      .asyncCallback()
      .then(() => {
        handleStatus('success')
      })
      .catch((err) => {
        console.error(err)
        setErrorMessage(err.message)
        handleStatus('error')
      })
  }, [refetch])

  switch (status) {
    case 'ready': {
      return <></>
    }
    case 'running': {
      return (
        <div>
          {loadingState ?? (
            <div className={'relative flex items-center justify-center'}>
              <LoaderSpin />
            </div>
          )}
        </div>
      )
    }
    case 'success': {
      return <>{children}</>
    }
    case 'error': {
      return <div className={'h3 text-red'}>Error: {errorMessage} </div>
    }
    default: {
      return { children }
    }
  }
}
